var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[(_vm.CHANNEL_PICTURE_URL)?_c('img',{staticClass:"header__icon",attrs:{"src":_vm.CHANNEL_PICTURE_URL}}):_vm._e(),_c('div',{staticClass:"header__title"},[_c('span',{staticClass:"header__title__text"},[_vm._v(_vm._s(_vm.CHANNEL_NAME))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }